import ANoticeHeader from './index.vue';

ANoticeHeader.install = app => {
  app.component(ANoticeHeader.name, ANoticeHeader);
};

export default ANoticeHeader;
